import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';

const AboutSection = () => {
  return (
    <div className="sm:flex items-center m-auto max-w-screen-xl py-8 px-4">
      <div className="sm:w-1/2 ml-0 sm:ml-8 p-4 sm:p-5">
        <div className="text">
          <span className="text-red-600 font-semibold uppercase tracking-wider text-sm border-b-2 border-red-600 pb-1 inline-block mb-3">
            About Us
          </span>
          <h2 className="my-2 font-extrabold text-3xl sm:text-4xl text-gray-900 leading-tight">
            Building High-Impact <span className="text-red-600">Shopify Stores</span>, Mobile Apps & SaaS MVPs
          </h2>
          <p className="text-gray-600 text-sm sm:text-base leading-relaxed mt-4">
            From engineering bespoke high-converting Shopify 2.0 storefronts and cross-platform Flutter/React Native mobile apps to building zero-to-one SaaS platforms and integrating intelligent AI automations, Core Spectators redefines digital excellence.
          </p>
          <p className="text-gray-600 text-sm sm:text-base leading-relaxed mt-3">
            Our mission is to empower your business with world-class software architecture, conversion-focused e-commerce, and autonomous AI systems—turning complex product roadmaps into scalable, revenue-generating reality.
          </p>
          <div className="mt-6">
            <Link
              to="/About"
              className="inline-flex items-center gap-2 text-red-600 font-bold hover:text-red-700 transition text-sm sm:text-base"
            >
              Learn More About Our Team <FaArrowRight className="text-xs" />
            </Link>
          </div>
        </div>
      </div>
      <div className="sm:w-1/2 p-4 sm:p-10 flex justify-center">
        <div className="image object-center text-center">
          <img src="/images/HomeAbout.svg" alt="About Core Spectators" className="w-full max-h-[380px] object-contain drop-shadow" />
        </div>
      </div>
    </div>
  );
};

export default AboutSection;
